import { render, staticRenderFns } from "./StickyHeaderHistoricalTrend.vue?vue&type=template&id=87b52362&scoped=true&"
import script from "./StickyHeaderHistoricalTrend.vue?vue&type=script&lang=js&"
export * from "./StickyHeaderHistoricalTrend.vue?vue&type=script&lang=js&"
import style0 from "./StickyHeaderHistoricalTrend.vue?vue&type=style&index=0&id=87b52362&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b52362",
  null
  
)

export default component.exports